import { styled } from "@phntms/css-components";
import { Section } from "../../components/Section";
import { ButtonLink } from "../../components/buttons/Button";
import { Card, TextCard } from "../../components/Card";
import styles from "./styles.module.scss";

export const StyledHorizontalSlidingCardsSection = styled(Section, {
  css: [styles.multiSlides, 'horizontal-sliding-cards-section'],
});

export const CtaButtonLink = styled(ButtonLink, {
  css: styles.cta,
});

export const HorizontalSlidingCard = styled(Card, {
  css: [styles.card, 'horizontal-sliding-card', 'card'],
});
export const HorizontalSlidingTextCard = styled(TextCard, {
  css: [styles.card, 'horizontal-sliding-text-card', 'card'],
});
